import { render, staticRenderFns } from "./MerchantDelegationsList.vue?vue&type=template&id=1969a655&scoped=true"
import script from "./MerchantDelegationsList.vue?vue&type=script&lang=js"
export * from "./MerchantDelegationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1969a655",
  null
  
)

export default component.exports